import { Trans, useTranslation } from 'react-i18next';
import { useModalContext } from '../../contexts/ModalContext';
import AppModal from './Modal';

const ModalUserCreated = () => {
    const { t } = useTranslation();
    const { createdUser, setCreatedUser } = useModalContext();

    const close = () => {
        setCreatedUser(null);
    };

    if (!createdUser) return <></>;

    return (
        <AppModal
            safeAction={close}
            safeText={t('button.close') as string}
        >
            <p>
                <Trans
                    i18nKey="feedback.user_saved"
                    values={{ user: createdUser }}
                />
            </p>
            <p>{t('feedback.email_sent_user')}</p>
        </AppModal>
    );
};

export default ModalUserCreated;
